export class DomHelper {
    public static addOrReplaceCustomCSS(css: string): void {
        const styleElementID = "dynamic-styles";
        let styleElement = document.getElementById(styleElementID) as HTMLStyleElement;

        // Créer l'élément <style> s'il n'existe pas
        if (!styleElement) {
            styleElement = document.createElement("style");
            styleElement.id = styleElementID;
            document.head.appendChild(styleElement);
        }

        styleElement.textContent = css;
    }
}
